import { FC, ReactNode, useEffect } from 'react';
// import Navbar from './navbar';
// import Footer from './footer';
import Consent from './consent';
import OldGlobalStyled from './OldGlobalStyled';
import AOS from 'aos';
import { Navbar } from '@components/Navbar';
import { Footer } from '@components/Footer';

interface Props {
  children: ReactNode | ReactNode[];
}

const OldLayout: FC<Props> = ({ children }) => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <Navbar forOldDesign={true} />
      <main>{children}</main>
      <Footer showLetsTalk={false} forOldDesign={true} />
      {/* <Consent /> */}

      <OldGlobalStyled />
    </>
  );
};

export default OldLayout;
